import { EquipmentItem } from '../../types';

export const EQUIPMENT_ITEMS: EquipmentItem[] = [
  // Kategorie Bälle
  {
    id: '1',
    name: 'Fussbälle Grösse 5',
    category: 'Bälle',
    inStock: true,
    description: 'Professionelle Fussbälle für Erwachsene und Jugendliche ab 13 Jahren',
    price: 0,
  },
  {
    id: '2',
    name: 'Fussbälle Grösse 4',
    category: 'Bälle',
    inStock: true,
    description: 'Fussbälle für Jugendliche von 8-12 Jahren',
    price: 0,
  },
  {
    id: '3',
    name: 'Fussbälle Grösse 3',
    category: 'Bälle',
    inStock: true,
    description: 'Fussbälle für Kinder unter 8 Jahren',
    price: 0,
  },
  
  // Kategorie Zubehör
  {
    id: '4',
    name: 'Ballsack',
    category: 'Zubehör',
    inStock: true,
    description: 'Robuster Ballsack für Transport und Lagerung von Fussbällen',
    price: 0,
  },
  {
    id: '5',
    name: 'Wasserflaschen',
    category: 'Zubehör',
    inStock: true,
    description: 'Sportliche Wasserflaschen für Training und Spiele',
    price: 0,
  },
  {
    id: '6',
    name: 'Wasserflaschenhalterung',
    category: 'Zubehör',
    inStock: true,
    description: 'Mobile Halterung für Wasserflaschen am Spielfeldrand',
    price: 0,
  },
  {
    id: '7',
    name: 'Trainingshütchen 40er Set',
    category: 'Zubehör',
    inStock: true,
    description: '40 Trainingshütchen in verschiedenen Farben',
    price: 0,
  },
  {
    id: '8',
    name: 'Trainingshütchen flach 24er Set',
    category: 'Zubehör',
    inStock: true,
    description: '24 flache Trainingshütchen in verschiedenen Farben',
    price: 0,
  },
  {
    id: '9',
    name: 'Erste-Hilfe Koffer',
    category: 'Zubehör',
    inStock: true,
    description: 'Vollständig ausgestatteter Erste-Hilfe Koffer für Sportvereine',
    price: 0,
  },
  
  // Kategorie Überziehleibchen
  {
    id: '10',
    name: 'Überziehleibchen Rot Kinder (10er Pack)',
    category: 'Überziehleibchen',
    inStock: true,
    description: 'Rote Überziehleibchen für Kinder, 10 Stück',
    price: 0,
  },
  {
    id: '11',
    name: 'Überziehleibchen Blau Kinder (10er Pack)',
    category: 'Überziehleibchen',
    inStock: true,
    description: 'Blaue Überziehleibchen für Kinder, 10 Stück',
    price: 0,
  },
  {
    id: '12',
    name: 'Überziehleibchen Gelb Kinder (10er Pack)',
    category: 'Überziehleibchen',
    inStock: true,
    description: 'Gelbe Überziehleibchen für Kinder, 10 Stück',
    price: 0,
  },
  {
    id: '13',
    name: 'Überziehleibchen Grün Kinder (10er Pack)',
    category: 'Überziehleibchen',
    inStock: true,
    description: 'Grüne Überziehleibchen für Kinder, 10 Stück',
    price: 0,
  },
  {
    id: '14',
    name: 'Überziehleibchen Rot Erwachsene (10er Pack)',
    category: 'Überziehleibchen',
    inStock: true,
    description: 'Rote Überziehleibchen für Erwachsene, 10 Stück',
    price: 0,
  },
  {
    id: '15',
    name: 'Überziehleibchen Blau Erwachsene (10er Pack)',
    category: 'Überziehleibchen',
    inStock: true,
    description: 'Blaue Überziehleibchen für Erwachsene, 10 Stück',
    price: 0,
  },
  {
    id: '16',
    name: 'Überziehleibchen Gelb Erwachsene (10er Pack)',
    category: 'Überziehleibchen',
    inStock: true,
    description: 'Gelbe Überziehleibchen für Erwachsene, 10 Stück',
    price: 0,
  },
  {
    id: '17',
    name: 'Überziehleibchen Grün Erwachsene (10er Pack)',
    category: 'Überziehleibchen',
    inStock: true,
    description: 'Grüne Überziehleibchen für Erwachsene, 10 Stück',
    price: 0,
  },
];